export default function (url) {
  try {
    let data = window.atob(url);
    if (typeof data === 'string' && data.indexOf('{') === 0) {
      data = JSON.parse(data);
    }
    return data;
  } catch (error) {
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/js/util/decrypt.js